import React, { useEffect, useState } from 'react';
import { css } from 'emotion';
import Text from 'shared/Text';
import { CarrotIcon } from 'shared/Icon/components/CarrotIcon';
import CreateAccountContainer from '../CreateAccountContainer';
import { ImportAgreement } from './ImportAgreement';
import {
  Wrapper,
  OverlayWrapper,
  Overlay,
  OverlayHeader,
  OverlayHeaderSection,
  OverlayContent,
} from './styles';
import { SwitchToAnchorHero } from './SwitchToAnchorHero';
import { Step } from './types';

type ImportCreateAccountProps = {
  stationId: string;
  userId: number;
  history: any;
  actions: {
    fetchTempVanitySlugFromPodcastName: () => void;
    redirectToSwitchPage: () => void;
    resetPersistedState: () => void;
  };
  onboarding: {
    rssFeed: string;
    rssFeedMetadata: {
      image: string;
      authorName: string;
    };
    vanitySlug: string;
  };
};

export const ImportCreateAccount = ({
  stationId,
  userId,
  history,
  actions: {
    fetchTempVanitySlugFromPodcastName,
    redirectToSwitchPage,
    resetPersistedState,
  },
  onboarding: { rssFeed, rssFeedMetadata, vanitySlug },
}: ImportCreateAccountProps) => {
  const [createAccountSuccess, setCreateAccountSuccess] = useState(false);
  useEffect(() => {
    fetchTempVanitySlugFromPodcastName();
  }, [fetchTempVanitySlugFromPodcastName]);

  // redirect away when the user refreshes the page or logs out
  if (!rssFeed || (createAccountSuccess && !userId)) {
    redirectToSwitchPage();
    return null;
  }

  return (
    <Wrapper>
      <SwitchToAnchorHero
        imageSrc={rssFeedMetadata.image}
        authorName={rssFeedMetadata.authorName}
      />
      <OverlayWrapper>
        <Overlay>
          <OverlayHeaderSection>
            <OverlayHeader>Create your account</OverlayHeader>
            <div
              className={css`
                text-align: center;
              `}
            >
              <Text
                size="md"
                isInline
                isBold
                color={createAccountSuccess ? '#a0a0a0' : '#15171a'}
              >
                Sign up
              </Text>
              <CarrotIcon
                className={css`
                  width: 5px;
                  margin: 0 5px;
                `}
              />
              <Text
                size="md"
                isInline
                isBold
                color={createAccountSuccess ? '#15171a' : '#a0a0a0'}
              >
                Import podcast
              </Text>
            </div>
          </OverlayHeaderSection>
          <OverlayContent>
            {createAccountSuccess ? (
              <ImportAgreement
                stationId={stationId}
                userId={userId}
                feedUrl={rssFeed}
                previousStep={Step.CREATE_ACCOUNT}
                history={history}
                resetPersistedState={resetPersistedState}
              />
            ) : (
              <div
                className={css`
                  max-width: 342px;
                  margin: auto;
                `}
              >
                <CreateAccountContainer
                  // @ts-ignore @TODO remove ignore after age gating experiment
                  submitCallback={() => setCreateAccountSuccess(true)}
                  vanitySlug={vanitySlug}
                  feedUrl={rssFeed}
                />
              </div>
            )}
          </OverlayContent>
        </Overlay>
      </OverlayWrapper>
    </Wrapper>
  );
};
